export const inventoryByExternalIdLocale: Record<string, string> = {
  b2b: $localize`:Config Strip|Inventory overview b2b label@@inventoryOverviewB2bLabel:B2B`,
  b2c: $localize`:Config Strip|Inventory overview b2c label@@inventoryOverviewB2cLabel:B2C`,
  free: $localize`:Config Strip|Inventory overview free label@@inventoryOverviewFreeLabel:FREE`,
  stock: $localize`:Config Strip|Inventory overview stock label@@inventoryOverviewStockLabel:STOCK`,
};
